import React from "react";
import { Alert } from "@mui/material";

const DSAlert = (props: React.ComponentProps<typeof Alert>) => {
  return <Alert {...props} />;
};

export default DSAlert;
